module.exports = __webpack_public_path__ + "img/konfigurasi_master_data.2ab0bd6e.svg";